module.exports = __webpack_public_path__ + "static/media/featured-3.78186c64.jpg";